import React from 'react';
import { Link } from 'react-router-dom';
export function SiteFooter() {
  return <footer className="border-t border-white/10 py-16 px-6" data-id="element-78" data-mp="3r8j5p2ritcpa">
      <div className="max-w-7xl mx-auto" data-id="element-79" data-mp="3r9186h4s0n5n">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-80" data-mp="3mh13ychob839">
          <div className="flex items-center space-x-3" data-id="element-81" data-mp="3hig62jpw90hz">
            <img src="https://cdn.magicpatterns.com/uploads/3vCu7oKxcfkEiVUzGfZBCk/Ari_Logo_White.png" alt="Ari OS" className="h-8" data-id="element-82" data-mp="3hhwtzjmxd6bv" />
          </div>
          <div className="flex flex-col items-center md:items-end gap-2" data-id="element-83" data-mp="38ggjzd00v686">
            <p className="text-gray-400 text-center md:text-right" data-id="element-84" data-mp="33jq4aqs4qcna">
              © 2026 AriOS created by RealWear. All rights reserved.
            </p>
            <div className="flex items-center gap-3 text-sm text-gray-400" data-id="element-85" data-mp="11rbpw1osnqbm">
              <a href="https://support.realwear.com/hubfs/Ari/ari_terms_of_use_realwear.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-86" data-mp="11qipdigfhx1x">
                Terms of Use
              </a>
              <span data-id="element-87" data-mp="1anvhrktdy4b2">|</span>
              <Link to="/conditions" className="hover:text-white transition-colors" data-id="element-88" data-mp="vsxompqexasx">
                Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}